export default __webpack_public_path__ + "static/swvl-7-a-9ca978e8f14dcce4572565526bd403bb.webp";